module.exports = __webpack_public_path__ + "static/media/image_pink.277c692e.png";